/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder, getDialogInitData } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { coalesce } from '@gh/core-util';

import {
  JobFinderBusinessService,
  JobFinderDialogConfig,
} from '../../resources/job-finder-business.service';
import { getJobFinderId, JobFinderListItem } from '../../resources/job-finder.model';
import { JobFinderGridDefinition } from './job-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-job-finder-dialog',
  templateUrl: 'job-finder-dialog.component.html',
  styleUrls: ['job-finder-dialog.component.scss'],
  providers: [JobFinderGridDefinition],
})
export class JobFinderDialogComponent
  extends AbstractFinderDialogComponent<JobFinderDialogConfig, JobFinderListItem>
  implements OnInit {

  form: FormState<any>;
  getId = getJobFinderId;

  defaultTitle = this.translations.get('lbl_find_job');

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              public gridDefinition: JobFinderGridDefinition,
              private translations: TranslationService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: JobFinderBusinessService) {
    super(dialogRef);
  }

  ngOnInit(): void {
    const { init } = getDialogInitData(this.dialogData);
    this.form = this.formStateBuilder.buildPlain({
      value: this.input.filter || { showFinalized: init.showFinalized, showDpp: false },
      children: {
        searchString: void 0,
        showFinalized: { enabled: coalesce(this.input.showFinalizedEnabled, true) },
        showDpp: { enabled: coalesce(this.input.showDppEnabled, true) },
      },
    });

    super.ngOnInit();
  }

  protected buildDataSource(): SlicedDataSource<JobFinderListItem> {
    return this.businessService.findAllAsDataSource({
      ...this.form.submitValue,
      showActive: true,
      showNotProceeding: true,
    });
  }
}
